<template>
  <div class="row vh-100">
    <div class="col-5" style="border-right: 1px solid #e0e0e0">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="Summary">
          
          <a-descriptions title="Order Details" layout="horizontal" size="small" bordered>
            <a-descriptions-item label="Batch #" span="2"> {{ this.cardOrderData.batch_number }} </a-descriptions-item>
            <a-descriptions-item label="Supplier" span="2"> {{ this.cardOrderData.supplier.name}} </a-descriptions-item>
            <a-descriptions-item label="Membership Program" span="3">{{ this.cardOrderData.membershipProgram.name }} | {{ this.cardOrderData.membershipLevel.name }}</a-descriptions-item>
            <!-- <a-descriptions-item label="Membership Level" span="2">{{ this.cardOrderData.membershipLevel.name }}</a-descriptions-item> -->
            <a-descriptions-item label="Card Type" span="3">{{ this.cardOrderData.cardType.name }}</a-descriptions-item>
            <a-descriptions-item label="Target Site" span="3">{{ this.cardOrderData.site.name }}</a-descriptions-item>
            <a-descriptions-item label="Status" span="3">
              <a-tag v-if="this.cardOrderData.cardOrderStatus.name == 'Posted'" color="#87d068">{{ this.cardOrderData.cardOrderStatus.name.toUpperCase() }}</a-tag>
              <a-tag v-else color="#ff9d5c">{{ this.cardOrderData.cardOrderStatus.name.toUpperCase() }}</a-tag>
            </a-descriptions-item>
            <a-descriptions-item label="Created By" span="2">{{ this.cardOrderData.createdBy.name }}</a-descriptions-item>
            <a-descriptions-item label="Approved By" span="2">{{ this.cardOrderData.approvedBy.name }}</a-descriptions-item>
          </a-descriptions>

          <br> 
          
          <a-descriptions title="Card Count Summary" layout="horizontal" size="small" bordered>
            <a-descriptions-item label="Total Quantity" span="6">{{ this.cardOrderData.fullCardDetails.length }}</a-descriptions-item>
            <a-descriptions-item label="Received" span="6">{{ this.cardListGrouped["Received"] ? this.cardListGrouped["Received"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="In-Transit from Supplier" span="6">{{ this.cardListGrouped["Ordered"] ? this.cardListGrouped["Ordered"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="In-Transit to Branch" span="6">{{ this.cardListGrouped["In-Transit"] ? this.cardListGrouped["In-Transit"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Activated" span="6">{{ this.cardListGrouped["Activated"] ? this.cardListGrouped["Activated"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Used" span="6">{{ this.cardListGrouped["Assigned"] ? this.cardListGrouped["Assigned"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Deactivated" span="6">{{ this.cardListGrouped["Deactivated"] ? this.cardListGrouped["Deactivated"].length : 0 }}</a-descriptions-item>
            <a-descriptions-item label="Rejected" span="6">{{ this.cardListGrouped["Rejected"] ? this.cardListGrouped["Rejected"].length : 0 }}</a-descriptions-item>
          </a-descriptions>

        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="col-7">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="Card List">
          <a-table 
              class="ant-table-striped"
              size="small"
              :columns="cardDisplayColumnsFull"
              :data-source="cardOrderData.fullCardDetails"
              :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped-2' : null)"
            />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
// import HTTPRequest from '../../controllers/httpRequest';
import { required } from 'vuelidate/lib/validators';
import secureStorage from '../../controllers/secureStorage';

export default {
  name: 'CardOrderForm',
  props: {
    cardOrderData: Object,
    viewMode: Boolean,
    selectedActions: Array
  },
  data() {
    return {
      cardListGrouped: {},
      cardDisplayColumnsFull: [
        { title: 'Card Type', key: 'card_type_name', dataIndex: 'card_type_name',},
        { title: 'Serial Number', key: 'serial_no', dataIndex: 'serial_no' },
        { title: 'Card Number', key: 'card_number', dataIndex: 'card_number' },
        { title: 'Status', key: 'card_status_name', dataIndex: 'card_status_name' },
      ],
      formSubmitting: false,
      currentSiteId: secureStorage.getItem('currentSiteId'),
      membershipPrograms: [],
      cardTypes: [],
      membershipLevels: [],
      sites: [],
      cardSuppliers: []
    };
  },
  validations: {
    formData: {
      membership_program_id: {
        required
      },
      membership_level_id: { required },
      card_type_id: { required },
      quantity: { required }
    }
  },
  methods: {
    
    closeDrawer() {
      this.$emit('closeDrawer', null);
    },
  },
  mounted() {
    this.$store.dispatch('setCurrentModule', 'Card Order');
    this.cardListGrouped = _.groupBy(this.cardOrderData.fullCardDetails, card => card.card_status_name);
    console.log("****************");
    console.log(this.cardListGrouped);
  }
};
</script>

<style scoped></style>
